import "./style.scss";

const TopBanner: React.FC = () => {
    return(
        <div className="TopBanner">
            <div className="longHeader flexItems flexDisplay noGap">
                <p className="smallSubheading">01252726833</p>
                <p className="smallSubheading companyTitle">Farnham and District Window Cleaning</p>
                <p className="smallSubheading">w.stewart76@btinternet.com</p>
            </div>
            <div className="smallHeader flexItems flexDisplay column noGap">
                <p className="smallSubheading companyTitle">Farnham and District Window Cleaning</p>
                <div className="TopBannerBottom flexItems flexDisplay gap">
                    <p className="smallSubheading">w.stewart76@btinternet.com</p>
                    <p className="smallSubheading">01252726833</p>
                </div>
            </div>
        </div>
    )
}

export default TopBanner;
